import React, { useState, useEffect, useCallback, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import API from "../../api";
import Loader from "../../components/Loader";
import styles from "./index.module.scss";
import JSONEditor from "jsoneditor";
import "jsoneditor/dist/jsoneditor.css";

const validateJson = (json) => {
  let meta = {
    isValid: true,
    errorMsg: null,
    summary: {},
  };
  json.forEach((fixture) => {
    if (fixture.lineups.length !== 2) {
      meta.isValid = false;
      meta.errorMsg = "Склади команд недоступні.";
    } else if (fixture.events.length === 0) {
      meta.isValid = false;
      meta.errorMsg = "Події матчу недоступні.";
    } else if (
      fixture.lineups[0].startXI
        .concat(fixture.lineups[1].startXI)
        .concat(fixture.lineups[0].substitutes)
        .concat(fixture.lineups[1].substitutes)
        .filter((player) => player.id === null).length > 0
    ) {
      meta.isValid = false;
      meta.errorMsg = "Нульовий айдішник гравця";
    } else if (
      fixture.events
        .filter((ev) => ev.type === "subst")
        .filter((ev) => ev.player.id === null || ev.assist.id === null).length >
      0
    ) {
      meta.isValid = false;
      meta.errorMsg = "Нульовий айдішник заміни";
    } else if (
      fixture.events
        .filter((ev) => ev.type === "Card")
        .filter((ev) => ev.player.id === null).length > 0
    ) {
      meta.isValid = false;
      meta.errorMsg = "Нульовий айдішник картки";
    } else {
      meta.summary.subst = fixture.events.filter(
        (ev) => ev.type === "subst"
      ).length;

      meta.summary.redcards = fixture.events.filter(
        (ev) => ev.detail === "Red Card"
      ).length;
      meta.summary.yellowcards = fixture.events.filter(
        (ev) => ev.detail === "Yellow Card"
      ).length;
      meta.summary.goals = fixture.events.filter(
        (ev) => ev.type === "Goal"
      ).length;
      meta.summary.numplayers =
        meta.summary.subst +
        fixture.lineups[0].startXI.length +
        fixture.lineups[1].startXI.length;
    }
  });

  return meta;
};

const Preview = ({ show, onHide }) => {
  const [loading, setLoading] = useState(false);
  const [json, setJson] = useState(null);
  const [isValid, setIsValid] = useState(false);
  const [error, setError] = useState(null);
  const [summary, setSummary] = useState(null);
  const editorEl = useRef(null);
  const editor = useRef(null);
  const fetchFixtures = useCallback(async () => {
    try {
      setLoading(true);
      const response = await API.fetchPreview();
      setJson(response.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (show) fetchFixtures();
  }, [show, fetchFixtures]);

  useEffect(() => {
    if (json === null) return;
    if (show) {
      editor.current = new JSONEditor(editorEl.current, { mode: "code" });
      editor.current.set(json);
    }
  }, [show, json]);

  const onHideModal = () => {
    onHide();
    setJson(null);
    setIsValid(false);
    setError(null);
    setSummary(null);
    editor.current.destroy();
  };

  const calcMatches = async () => {
    try {
      setLoading(true);
      await API.calcMatches(editor.current.get());
      await API.generateStandings();
      onHideModal();
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const validate = () => {
    const newJson = editor.current.get();
    console.log(newJson);
    const { isValid, errorMsg, summary } = validateJson(newJson);
    setError(errorMsg);
    setIsValid(isValid);
    setSummary(summary);
  };

  return (
    <Modal show={show} size="lg" onHide={onHideModal}>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-calculator"></i>Прев'ю
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ minHeight: 584 }}>
        {loading ? (
          <Loader isAbsolute />
        ) : (
          <>
            <div
              ref={editorEl}
              style={{ width: "100%", height: 500 }}
              id="json-editor"
            ></div>

            <div className={styles.actions}>
              <div className={styles.leftPanel}>
                <Button onClick={validate}>Валідувати</Button>
                {error && (
                  <span style={{ color: "red", marginLeft: 8 }}>{error}</span>
                )}
                {summary?.numplayers > 0 && (
                  <span className={styles.summary}>
                    <span style={{ marginLeft: 8 }}>
                      <i className="bi bi-people-fill"></i>&nbsp;
                      {summary?.numplayers}
                    </span>
                    <span style={{ marginLeft: 8 }}>
                      <i className="bi bi-arrow-clockwise"></i> {summary?.subst}
                    </span>
                    <span style={{ marginLeft: 8 }}>
                      <i className="bi bi-box"></i> {summary?.yellowcards}
                    </span>
                    <span style={{ marginLeft: 8 }}>
                      <i className="bi bi-box-fill"></i> {summary?.redcards}
                    </span>
                    <span style={{ marginLeft: 8 }}>
                      <i className="bi bi-bullseye"></i> {summary?.goals}
                    </span>
                  </span>
                )}
              </div>
              {isValid && (
                <Button
                  disabled={loading}
                  variant="danger"
                  onClick={calcMatches}
                >
                  Зберегти
                </Button>
              )}
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default Preview;
